// extracted by mini-css-extract-plugin
export var emptyState = "_62-d";
export var statCard = "_62-c";
export var table = "_62-0";
export var tableCell = "_62-4";
export var tableCellClickable = "_62-5 _62-4";
export var tableCellDefault = "_62-6 _62-4";
export var tableCellEmpty = "_62-8";
export var tableCellWithValue = "_62-7";
export var tableContainer = "_62-e";
export var tableHeaderWeight = "_62-1";
export var tableHeaderZone = "_62-2";
export var tableRowHeader = "_62-3";
export var viewModeButton = "_62-9";
export var viewModeButtonActive = "_62-a _62-9";
export var viewModeButtonInactive = "_62-b _62-9";